<template>
  <div class="tekmodal">
    <!-- MODAL HEADER -->
    <div class="modalheader">
      <div class="headerleft">
        <div class="ico">
          <img src="../../assets/sidebar/tekenaars-ico.svg" alt="" />
        </div>
        <h4 class="header">Tekenaar</h4>
      </div>
      <div class="header-buttons">
        <button @click="openEmailPopup">Stuur email</button>
        <div class="close-btn" @click="closemodal">
          <img src="../../assets/close-btn.png" alt="" class="close-x" />
        </div>
      </div>
    </div>

    <!-- SAVE CHANGES sectie -->
    <div class="savesection" v-if="isTekenaarEdited == true" @click="saveChanges()">
      <span>Sla veranderingen op</span>
    </div>

    <!-- MODAL HEADER sectie -->
    <div class="section blue">
      <!-- <span class="titeltekst">{{ tekenaar[0].voornaam }}</span> -->
      <div class="titelholder">
        <input type="text" id="field1" class="tekstveld blue titeltekst" v-model="tekenaar[0].voornaam" @input="isTekenaarEdited = true" />
        <input type="text" class="tekstveld blue titeltekst resizefield" v-model="tekenaar[0].achternaam" @input="isTekenaarEdited = true" />
      </div>

      <div class="threecolumnsholder">
        <div>
          <input type="text" class="tekstveld blue" v-model="tekenaar[0].email" @input="isTekenaarEdited = true" />
          <input type="text" class="tekstveld blue" v-model="tekenaar[0].telefoonnummer" @input="isTekenaarEdited = true" />
        </div>
        <div>
          <input type="text" class="tekstveld blue" v-model="tekenaar[0].werkgebied" @input="isTekenaarEdited = true" placeholder="werkgebied" />
          <input type="text" class="tekstveld blue" v-model="tekenaar[0].bedrijfsnaam" @input="isTekenaarEdited = true" />
        </div>
      </div>
      <div class="threecolumnsholder">
        <div>
          <input type="text" class="tekstveld blue" v-model="tekenaar[0].tekenprogramma" @input="isTekenaarEdited = true" placeholder="tekenprogramma" />
          <input type="text" class="tekstveld blue" v-model="tekenaar[0].kvknummer" @input="isTekenaarEdited = true" placeholder="kvk nummer" />
        </div>
        <div>
          <input type="text" class="tekstveld blue" v-model="tekenaar[0].woonplaats" @input="isTekenaarEdited = true" />
          <input type="text" class="tekstveld blue" v-model="tekenaar[0].adres" @input="isTekenaarEdited = true" placeholder="adres" />
        </div>
      </div>
      <div class="threecolumnsholder">
        <div>
          <input type="text" class="tekstveld blue" v-model="tekenaar[0].opleiding" @input="isTekenaarEdited = true" placeholder="opleiding" />
        </div>
        <div>
          <!-- hier passen 2 extra velden -->
        </div>
      </div>
      <div style="padding-top: 20px">
        <div class="discholder" style="padding-top: 10px; padding-bottom: 0px">
          <span>Disciplines van deze tekenaar:</span>
        </div>
      </div>
    </div>

    <!-- MORE INFO sectie -->
    <div class="section">
      <span class="titeltekst">Aantekening</span>
      <div class="discholder" style="padding-top: 10px">
        <textarea class="aantekening" v-model="tekenaar[0].aantekening" @input="isTekenaarEdited = true"></textarea>
      </div>
    </div>

    <div class="section">
      <div class="herobarting">
        <span class="titeltekst">Opdrachten</span>
        <span class="discipline-orange">{{ opdrachtenVanTekenaar.length }}</span>
      </div>

      <div class="vertical">
        <div v-if="opdrachtenVanTekenaar.length >= 0" style="padding-top: 15px">
          <div class="opdracht" v-for="opdracht in opdrachtenVanTekenaar" :key="opdracht.id" @click="$emit('select-opdracht', opdracht.id)">
            <span class="opdracht-bedrijfsnaam">{{ opdracht.bedrijfsnaam }}</span>
            <Voortgang class="tingting" :opdracht="opdracht" />
          </div>
        </div>
        <div v-if="opdrachtenVanTekenaar.length == 0" style="padding-top: 15px">
          <div>
            <span>Deze tekenaar heeft nog geen opdrachten</span>
          </div>
        </div>
      </div>
    </div>

    <!-- log sectie -->
    <div v-if="tekenaar[0].log != undefined" class="section2">
      <span class="titeltekst">Log</span>
      <div class="vertical">
        <div style="padding-top: 15px">
          <div v-for="logentry in orderBy(tekenaar[0].log, 'id', -1)" :key="logentry.id" class="logentry">
            <span v-if="logentry.manual" class="manuallogentry"> </span>
            <span>{{ logentry.log }}</span
            ><br />
            <span style="opacity: 0.5; font-size: 13px"> {{ timestampReadable(logentry.timestamp) }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Annuleer tekenaar sectie -->
    <div @click="deleteTekenaar" class="section annuleersection">
      <img src="../../assets/trashcan-ico-red.png" style="max-width: 20px" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import store from "../../store"

import Vue2Filters from "vue2-filters"

import Voortgang from "../ui-elements/VoortgangZonderHeader"

export default {
  name: "TekModal",
  components: {
    Voortgang
  },
  mixins: [Vue2Filters.mixin],

  data() {
    return {
      isTekenaarEdited: false,
      options: ["Bouwkunde", "Werktuigbouwkunde", "Installatietechniek", "Elektrotechniek", "Brandpreventie", "Huisvesting", "Plattegronden", "Concepten - 3D Print", "Nen2580"]
    }
  },
  props: {
    tekenaarsid: String
  },
  computed: {
    ...mapGetters(["allTekenaars", "allOpdrachten"]),
    tekenaar() {
      return this.allTekenaars.filter(tekenaar => {
        if (tekenaar.id == this.tekenaarsid) {
          return tekenaar
        }
      })
    },
    opdrachtenVanTekenaar() {
      return this.allOpdrachten.filter(opdracht => {
        if (this.tekenaar[0].id == opdracht.tekenaarsid) {
          return opdracht
        }
      })
    }
  },
  methods: {
    openEmailPopup() {
      store.commit("SET_EMAILDATA_SENDTOID", this.tekenaar[0].id)
      store.commit("SET_EMAILPOPUP_VISIBILITY", true)
    },
    resizeInput() {
      this.attr("size", this.val().length)
    },
    deleteTekenaar() {
      if (this.opdrachtenVanTekenaar.length == 0) {
        if (confirm("LET OP! Deze tekenaar definitief verwijderen?")) {
          store.dispatch("deleteTekenaar", this.tekenaar[0].id)
        }
      } else {
        alert("Deze tekenaar kan NIET worden verwijderd omdat hij nog gekoppeld staat aan 1 of meerdere opdrachten")
      }
    },
    saveChanges() {
      store.dispatch("saveTekChanges", this.tekenaar[0])
      this.isTekenaarEdited = false
    },

    closemodal() {
      if (this.isTekenaarEdited == false) {
        this.$emit("close-Modal")
      } else {
        alert("Sla eerst de gemaakte wijzigingen op!")
      }
    },
    timestampReadable(e) {
      var d = new Date(e)
      return d.toGMTString()
    }
  }
}
</script>

<style>
.multiselect,
.multiselect__tags {
  background-color: #e4ecfa !important;
  border: none !important;
  padding-left: 0 !important;
}

.multiselect__tag {
  border-radius: 16px !important;
  padding: 10px 36px 10px 10px !important;
}
.multiselect__tag-icon {
  top: 5px !important;
  right: 6px !important;
}
.multiselect__input {
  display: none !important;
}
.multiselect__select {
  background-color: rgb(255, 255, 255, 0.5);
  border-radius: 100%;
  padding: 0 !important;
}
.multiselect__select:hover {
  background-color: rgb(255, 255, 255, 1);
}
</style>

<style scoped>
.titelholder {
  display: flex;
}
.titelholder .tekstveld {
  width: 50%;
}

button {
  background-color: #3076ea;
  padding: 10px;
  border-radius: 4px;
  color: white;
  border: none;
  cursor: pointer;
  font-weight: 600;
  margin-right: 20px;
  font-size: 15px;
  transition: 0.2s;
}
button:hover {
  opacity: 0.8;
}

@media screen and (max-width: 663px) {
  .tekmodal {
    padding-bottom: 100px;
  }
}

.tingting {
  position: absolute;
  right: 40px;
  padding-left: 30px;
  background: rgb(255, 255, 255);
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 10%, rgba(255, 255, 255, 1) 100%);
}

.opdracht-bedrijfsnaam {
  white-space: nowrap;
}

.tekmodal .annuleersection {
  padding: 20px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: fixed !important;
  bottom: 0;
  top: unset !important;
  background-color: #e4ecfa;
  max-width: 520px;

  cursor: pointer;
}
.annuleersection:hover {
  background-color: #e3170a87;
}

.discipline-orange {
  background-color: #ff9323;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  font-size: 13px;
  color: white;
  border: 2px solid white;
}

.herobarting {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.blue {
  background-color: #e4ecfa;
  /* color: #fff; */
  position: sticky !important;
  top: 70px;
  z-index: 1;
}

.blue.tekstveld {
  background: none;
}

/* .tekstveld.blue:hover {
        background-color: #1b4d8d;
    }
    .tekstveld.blue:focus {
        background-color: #1b4d8d;
    } */

.header {
  color: #fff;
  font-weight: 600;
  padding-right: 30px;
  font-size: 18px;
}
.headerleft {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.ico {
  background-color: #ff9326;
  width: 28px;
  height: 28px;
  border-radius: 5px;
  padding: 4px;
  margin-right: 10px;
}

.header-buttons {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.deletebutton {
  background-color: #ff9326;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  cursor: pointer;
  margin-right: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 1px;
}

.close-btn {
  width: 24px;
  height: 24px;
  display: flex;
  cursor: pointer;
  transition: 0.3s;
}
.close-btn:hover {
  transform: scale(1.2);
}

.delete-image {
  height: 16px;
}

.savesection {
  background-color: #ff9326;
  color: #fff;
  display: flex;
  width: 100%;
  max-width: 520px;
  padding: 24px;
  justify-content: center;
  cursor: pointer;
  font-weight: 600;
  position: fixed;
  bottom: 0;
  z-index: 1;
}

.opdracht {
  padding: 10px 0px;
  border-bottom: 1px solid #e4ecfa;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.opdracht:hover {
  background-color: #e4ecfa;
}
.opdracht:hover .tingting {
  background: rgb(228, 236, 250);
  background: linear-gradient(90deg, rgba(228, 236, 250, 0) 0%, rgba(228, 236, 250, 1) 10%, rgba(228, 236, 250, 1) 100%);
}

.tekmodal {
  z-index: 4;
  position: fixed;
  overflow-y: scroll;
  left: auto;
  max-width: 520px;
  top: 0%;
  right: 0%;
  bottom: 0%;
  min-width: 520px;
  background-color: #fff;
  box-shadow: -20px 0 50px 0 rgba(0, 0, 0, 0.11);
}
.modalheader {
  display: flex;
  height: 70px;
  padding: 0 25px;
  justify-content: space-between;
  align-items: center;
  background-color: #1b4d8d;
  color: white;
  font-size: 16px;
  font-weight: 600;
  position: sticky;
  top: 0px;
  z-index: 5;
}

.section {
  padding: 40px;
  position: relative;
  border-bottom: 1px solid #e4ecfa;
}

.section2 {
  padding: 40px;
  position: relative;
  padding-bottom: 300px;
}

.titeltekst {
  font-weight: 600;
  font-size: 20px !important;
}

.threecolumnsholder {
  display: flex;
  justify-content: space-between;
  align-items: top;
  width: 100%;
}

.threecolumnsholder div {
  width: 100%;
  padding-top: 15px;
  font-size: 15px;
  display: flex;
  flex-direction: column;
}

.vertical {
  display: flex;
  flex-direction: column;
}

.discipline {
  background-color: #e4ecfa;
  border-radius: 100px;
  padding: 5px 10px;
  margin-bottom: 15px;
  display: inline-block;
  /* display: flex;
        align-items: center;
        justify-content: center; */
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  margin-right: 7px;
  /* border: 2px solid white; */
}

.tekstveld {
  font-size: 15px;
  font-family: "Poppins", sans-serif;
  border: 0px;
}
.tekstveld:hover {
  background-color: #ffdab5;
  cursor: pointer;
}
.tekstveld:focus {
  background-color: #ffdab5;
}

.aantekening {
  font-family: "Poppins", sans-serif;
  height: 170px;
  font-size: 16px;
  border-width: 0px;
  width: 100%;
  /* background-color: #E4ECFA; */
  /* padding: 14px; */
  /* border-radius: 5px; */
}
.aantekening:hover {
  background-color: #ffdab5;
  cursor: pointer;
}
.aantekening:focus {
  background-color: #ffdab5;
}
</style>
